export default __webpack_public_path__ + "static/media/05.b1bf7b3f.png";